import React from 'react';
import { useDrop } from 'react-dnd';
import KanbanDraggableCard from './KanbanDraggableCard';

export default function KanbanColumn({
  column,
  onMoveCardIdBased,
  onPatch,
  onCardClick,
  typeCard,
}) {
  const [{ isOver }, dropCol] = useDrop({
    accept: typeCard,
    canDrop: item => item.fromColumnId !== column.id,
    drop(originalItem, monitor) {
      if (!monitor.isOver({ shallow: true })) return;

      // 🚫 same column? do nothing
      if (originalItem.fromColumnId === column.id) return;

      // extra safety: respect canDrop
      if (!monitor.canDrop()) return;

      const item = { ...originalItem };

      onMoveCardIdBased(
        item.card,
        item.fromColumnId,
        column.id,
        column.cards.length,
        {
          beforeId: column.cards.at(-1)?.id ?? null,
          afterId: null,
        },
      );

      item.fromColumnId = column.id;
      item.fromIndex = column.cards.length - 1;
    },
    collect: monitor => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
  });

  const moveCard = React.useCallback(
    (card, fromColId, fromIdx, toColId, toIdx) => {
      const beforeId = column.cards[toIdx - 1]?.id ?? null;
      const afterId = column.cards[toIdx]?.id ?? null;
      onMoveCardIdBased(card, fromColId, toColId, toIdx, { beforeId, afterId });
    },
    [onMoveCardIdBased, column.cards],
  );

  const onUpdateCard = React.useCallback(
    (cardId, patch) => onPatch(cardId, patch),
    [onPatch],
  );

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 290,
        alignItems: 'stretch',
        boxSizing: 'border-box',
        background: isOver ?? 'rgba(25,118,210,0.06)',
        borderRadius: 12,
      }}
    >
      <div
        style={{
          flex: '0 0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 500,
          marginBottom: 8,
          backgroundColor: '#525252',
          color: '#FFFFFF',
          top: 0,
          position: 'sticky',
          zIndex: 10,
        }}
      >
        {`${column.name} (${column.cards?.length ?? 0})`}
      </div>

      <div
        ref={dropCol}
        style={{
          flex: 1,
          minHeight: 0,
          padding: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
          position: 'relative',
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
          background: '#F8F8F8',
          outline: isOver ? '2px dashed rgba(25,118,210,0.45)' : 'none',
          outlineOffset: -4,
        }}
      >
        {column.cards.map((card, idx) => (
          <KanbanDraggableCard
            key={card.id}
            card={card}
            index={idx}
            columnId={column.id}
            moveCard={(fromColId, fromIdx, toColId, toIdx) => (
              moveCard(card, fromColId, fromIdx, toColId, toIdx)
            )}
            onUpdateCard={onUpdateCard}
            onCardClick={onCardClick}
            typeCard={typeCard}
          />
        ))}
        <div style={{ flex: 1, minHeight: 48 }} />
      </div>

    </div>
  );
}
